var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateAd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C7.16922 0 0 7.16922 0 16C0 24.8308 7.16922 32 16 32C24.8308 32 32 24.8308 32 16C32 7.16922 24.8308 0 16 0ZM16 2.13333C23.6532 2.13333 29.8667 8.34682 29.8667 16C29.8667 23.6532 23.6532 29.8667 16 29.8667C8.34682 29.8667 2.13333 23.6532 2.13333 16C2.13333 8.34682 8.34682 2.13333 16 2.13333ZM14.9333 14.9333H7.46667C6.87785 14.9333 6.4 15.4112 6.4 16C6.4 16.5888 6.87785 17.0667 7.46667 17.0667H14.9333V24.5333C14.9333 25.1221 15.4112 25.6 16 25.6C16.5888 25.6 17.0667 25.1221 17.0667 24.5333V17.0667H24.5333C25.1221 17.0667 25.6 16.5888 25.6 16C25.6 15.4112 25.1221 14.9333 24.5333 14.9333H17.0667V7.46667C17.0667 6.87785 16.5888 6.4 16 6.4C15.4112 6.4 14.9333 6.87785 14.9333 7.46667V14.9333Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAd);
export default __webpack_public_path__ + "static/media/create_ad.03899ff9e19a51c5b8368d069383b05c.svg";
export { ForwardRef as ReactComponent };